import { getRoot, Instance, types } from 'mobx-state-tree';
import { PageModel, RootType } from '../../../internal';
import {
  QuizListModel,
  QuizListModelType,
} from '../../../models/domain/quiz/QuizListModel';

export const SviKvizoviModel = types
  .compose(
    PageModel,
    types.model({
      quizList: types.optional(QuizListModel, { rows: [] }),
    })
  )
  .views((self) => ({
    get root(): RootType {
      return getRoot(self);
    },
  }))
  .actions((self) => ({
    async beforePageEnter() {
      const response = await self.root.api.quiz.getAll();
      self.quizList.setElements(response);
    },
    getQuizList(): QuizListModelType {
      return self.quizList;
    },
    async deleteQuiz(quizId: number) {
      await self.root.api.quiz.deleteQuiz(quizId);
      const updated = await self.root.api.quiz.getAll();
      self.quizList.setElements(updated);
    },
  }))
  .named('SviKvizoviModel');

export type SviKvizoviModelType = Instance<typeof SviKvizoviModel>;
